import { ArrowBack } from '@mui/icons-material';
import { Button } from 'components';
import * as React from 'react';
import { Link, useLocation, useNavigate } from 'react-router';
import { getBreadcrumbsListDataFromPath } from '../../../utils/navigation';
import './BreadcrumbsBlock.styled.scss';
import { HOME_BREADCRUMB } from './BreadcrumbsBlock.constants';
import classNames from 'classnames';
import { capitalizeFirst } from '../../../utils/index';
import { TBreadcrumbs } from './BreadcrumbsBlock.types';
import { useLocalize } from 'store/contexts/LocalizationContext/LocalizationContext.provider';

export const BreadcrumbsBlock: TBreadcrumbs = ({ idHelpers }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const localize = useLocalize();

  const handleBack = () => navigate(-1);

  return (
    <div className="breadcrumbs-block">
      <Button
        className="breadcrumbs-block__back-button"
        variant="text"
        startIcon={<ArrowBack />}
        color="secondary"
        sx={{ minWidth: '32px' }}
        onClick={handleBack}
      />
      <div className="breadcrumbs-block__bar">
        <Link
          to={HOME_BREADCRUMB.to}
          className={classNames('breadcrumbs-block__bar__item', 'caption', {
            'breadcrumbs-block__bar__item--active':
              pathname === HOME_BREADCRUMB.to,
          })}
        >
          {localize(HOME_BREADCRUMB.label)}
        </Link>
        {getBreadcrumbsListDataFromPath(pathname, idHelpers, localize).map(
          (breadcrumb) => (
            <>
              /
              <Link
                key={breadcrumb.to}
                to={breadcrumb.to}
                className={classNames(
                  'breadcrumbs-block__bar__item',
                  'caption',
                  {
                    'breadcrumbs-block__bar__item--active': breadcrumb.isActive,
                  }
                )}
              >
                {capitalizeFirst(breadcrumb.label)}
              </Link>
            </>
          )
        )}
      </div>
    </div>
  );
};
